export class FundConstants {
	static readonly WithoutDetailFunds: number[] = [11277];

	static readonly FundName: { [fundCode: number]: string } = {
		11132: 'امید توسعه',
		10600: 'پیشتاز',
		10762: 'ممتاز',
		10851: 'پیشرو',
		11562: 'نامی',
		12021: 'تضمین',
		11277: 'حامی',
		12033: 'توان',
		12217: 'صندوق آتیه مفید'
	};

	static readonly FundIcon: { [fundCode: number]: string } = {
		10600: 'logo-pishtaz',
		10851: 'logo-pishro',
		11132: 'logo-omid',
		10762: 'logo-momtaz',
		11562: 'logo-nami',
		12021: 'logo-tazmin',
		11277: 'logo-hami',
		12033: 'logo-tavan',
		12217: 'logo-atieh'
	};

	static readonly TransactionStateClass: { [status: number]: string } = {
		1: 'fund-detail-tree-st-current',
		2: 'fund-detail-tree-st-done',
		3: 'fund-detail-tree-st-reject',
		4: 'fund-detail-tree-st-remove'
	};
}
